/*! @pentacode/ui v0.1.0 */
import { t as e } from "../../../styledElement-Dm1irIE2.js";
import { t } from "../../../decorateMetadata-BhwOl-pv.js";
import { t as n } from "../../../decorate-DHgd5sZx.js";
import { FormElement as r } from "../../formElement.js";
import "../../../checkbox-BOki-Nk5.js";
import "../../form-elements/select.js";
import "../../form-elements/text-input.js";
import { LitElement as i, html as a, nothing as o } from "lit";
import { customElement as s, property as c, state as l } from "lit/decorators.js";
//#region src/elements/employee-questionnaire/shared/general-section.ts
var u = [
	{
		label: "Ja",
		value: "yes"
	},
	{
		label: "Nein",
		value: "nein"
	},
	{
		label: "Unbestimmt",
		value: "unbestimmt"
	}
], d = [
	{
		label: "Steuerklasse 1",
		value: "1"
	},
	{
		label: "Steuerklasse 2",
		value: "2"
	},
	{
		label: "Steuerklasse 3",
		value: "3"
	},
	{
		label: "Steuerklasse 4",
		value: "4"
	},
	{
		label: "Steuerklasse 5",
		value: "5"
	},
	{
		label: "Steuerklasse 6",
		value: "6"
	}
], f = [
	{
		label: "Keine",
		value: ""
	},
	{
		label: "Römisch-Katholisch",
		value: "catholic"
	},
	{
		label: "Evangelisch",
		value: "evangelical"
	},
	{
		label: "Andere",
		value: "other"
	}
], p = class extends e(r(i)) {
	constructor(...e) {
		super(...e), this.data = { mainJob: !1 }, this._occupation = "", this._passportNumber = "", this._mainJob = !1, this._pvBonusChildren = "", this._taxClass = "", this._taxClass4Factor = void 0, this._childrenFreeAmount = "", this._confession = "";
	}
	willUpdate(e) {
		e.has("data") && this.data && (this._occupation = this.data.occupation ?? "", this._passportNumber = this.data.passportNumber ?? "", this._mainJob = this.data.mainJob, this._pvBonusChildren = this.data.pvBonusChildren ?? "", this._taxClass = this.data.taxClass ?? "", this._taxClass4Factor = this.data.taxClass4Factor, this._childrenFreeAmount = this.data.childrenFreeAmount ?? "", this._confession = this.data.confession ?? "");
	}
	_handleSectionChange() {
		this._taxClass !== "4" && (this._taxClass4Factor = void 0), this.dispatchEvent(new CustomEvent("change", {
			detail: {
				occupation: this._occupation || void 0,
				passportNumber: this._passportNumber || void 0,
				mainJob: this._mainJob,
				pvBonusChildren: this._pvBonusChildren || void 0,
				taxClass: this._taxClass || void 0,
				taxClass4Factor: this._taxClass4Factor,
				childrenFreeAmount: this._childrenFreeAmount || void 0,
				confession: this._confession || void 0
			},
			bubbles: !0,
			composed: !0
		}));
	}
	render() {
		return a`
            <section class="w-full">
                <h2 class="mb-4 px-2 text-xl font-semibold">Steuerliche Angaben</h2>

                <div class="flex flex-col gap-4">
                    <div class="flex gap-4">
                        <div class="flex-1">
                            <ptc-ui-text-input
                                name="occupation"
                                label="Ausgeübte Tätigkeit"
                                placeholder="Tätigkeit eingeben"
                                .value=${this._occupation}
                                maxlength="200"
                                @change=${(e) => {
			e.stopPropagation(), this._occupation = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-text-input>
                        </div>

                        <div class="flex-1">
                            <ptc-ui-text-input
                                name="passportNumber"
                                label="Ausweis- oder Reisepassnummer"
                                placeholder="Ausweisnummer eingeben"
                                .value=${this._passportNumber}
                                maxlength="20"
                                @change=${(e) => {
			e.stopPropagation(), this._passportNumber = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-text-input>
                        </div>
                    </div>

                    <div class="flex items-center gap-2 px-2">
                        <ptc-ui-checkbox
                            id="mainJob"
                            name="mainJob"
                            .checked=${this._mainJob}
                            @change=${(e) => {
			e.stopPropagation(), this._mainJob = e.detail.checked, this._handleSectionChange();
		}}
                        ></ptc-ui-checkbox>
                        <label for="mainJob" class="text-sm font-medium text-gray-700"
                            >Diese Beschäftigung ist meine Hauptbeschäftigung</label
                        >
                    </div>

                    <div class="flex items-end gap-4">
                        <div class="flex-1">
                            <ptc-ui-select
                                .options=${u}
                                name="pvBonusChildren"
                                label="Berücksichtigungsfähige Kinder für PV-Zuschlag"
                                .value=${this._pvBonusChildren}
                                @change=${(e) => {
			e.stopPropagation(), this._pvBonusChildren = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-select>
                        </div>

                        <div class="flex-1">
                            <ptc-ui-select
                                .options=${d}
                                name="taxClass"
                                label="Steuerklasse"
                                .value=${this._taxClass}
                                @change=${(e) => {
			e.stopPropagation(), this._taxClass = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-select>
                        </div>
                    </div>

                    ${this._taxClass === "4" ? a`
                              <div class="flex gap-4">
                                  <div class="flex-1">
                                      <ptc-ui-text-input
                                          type="number"
                                          name="taxClass4Factor"
                                          label="Faktor für Steuerklasse 4"
                                          placeholder="z.B. 0.5"
                                          step="0.01"
                                          min="0"
                                          max="1"
                                          .value=${this._taxClass4Factor?.toString() ?? ""}
                                          @change=${(e) => {
			e.stopPropagation(), this._taxClass4Factor = e.detail.value ? parseFloat(e.detail.value) : void 0, this._handleSectionChange();
		}}
                                      ></ptc-ui-text-input>
                                  </div>
                                  <div class="flex-1"></div>
                              </div>
                          ` : o}

                    <div class="flex gap-4">
                        <div class="flex-1">
                            <ptc-ui-text-input
                                name="childrenFreeAmount"
                                label="Kinderfreibetrag"
                                placeholder="z.B. 0.5, 1, 2.5"
                                .value=${this._childrenFreeAmount}
                                @change=${(e) => {
			e.stopPropagation(), this._childrenFreeAmount = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-text-input>
                        </div>

                        <div class="flex-1">
                            <ptc-ui-select
                                .options=${f}
                                name="confession"
                                label="Konfession"
                                .value=${this._confession}
                                @change=${(e) => {
			e.stopPropagation(), this._confession = e.detail.value, this._handleSectionChange();
		}}
                            ></ptc-ui-select>
                        </div>
                    </div>
                </div>
            </section>
        `;
	}
};
n([c({ type: Object }), t("design:type", Object)], p.prototype, "data", void 0), n([l(), t("design:type", Object)], p.prototype, "_occupation", void 0), n([l(), t("design:type", Object)], p.prototype, "_passportNumber", void 0), n([l(), t("design:type", Object)], p.prototype, "_mainJob", void 0), n([l(), t("design:type", Object)], p.prototype, "_pvBonusChildren", void 0), n([l(), t("design:type", Object)], p.prototype, "_taxClass", void 0), n([l(), t("design:type", Object)], p.prototype, "_taxClass4Factor", void 0), n([l(), t("design:type", Object)], p.prototype, "_childrenFreeAmount", void 0), n([l(), t("design:type", Object)], p.prototype, "_confession", void 0), p = n([s("ptc-ui-employee-questionnaire-general-section")], p);
//#endregion
export { p as EmployeeQuestionnaireGeneralSection };

//# sourceMappingURL=general-section.js.map